"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
var file_1 = __importDefault(require("relements/build/esm/input/file"));
var text_1 = __importDefault(require("relements/build/esm/input/text"));
var chips_1 = __importDefault(require("relements/build/esm/input/chips"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var radio_1 = __importDefault(require("relements/build/esm/input/radio"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var whatsapp_logo_circle_svg_1 = __importDefault(require("@src/components/Icon/whatsapp-logo-circle.svg"));
var messenger_logo_circle_svg_1 = __importDefault(require("@src/components/Icon/messenger-logo-circle.svg"));
var instagram_logo_circle_svg_1 = __importDefault(require("@src/components/Icon/instagram-logo-circle.svg"));
var store_1 = __importDefault(require("@src/store"));
var chatIcon_1 = __importDefault(require("./chatIcon"));
var SDKChatIcon_1 = __importDefault(require("../SDKChatIcon"));
var notification_1 = __importDefault(require("../notification"));
var tabs_1 = require("./tabs");
var OmniChannelWidget_1 = __importDefault(require("../OmniChannelWidget"));
var notificationTypes_1 = __importDefault(require("./notificationTypes"));
var languageIcon_1 = __importDefault(require("./languageIcon"));
var WhiteListDomain_js_1 = __importDefault(require("../WhiteListDomain/WhiteListDomain.js"));
var messageSoundTypes_1 = __importDefault(require("./messageSoundTypes"));
var INPUTS = (_a = {},
    _a[tabs_1.CHANNEL_PATHS.SDK_CONFIGURATIONS] = {
        blocks: [
            {
                title: 'Common Configurations (JS, iOS, Android)',
                inputs: [
                    {
                        label: 'Business Icon',
                        key: 'businessIcon',
                        component: file_1["default"],
                        props: {
                            placeholder: 'Upload Business Icon',
                            prefixClassName: 'business-icon-logo',
                            dimensions: '256px X 256px',
                            type: 'image',
                            maxFileSize: 1,
                            tooltip: 'This icon will be visible on the header of the JS SDK Chat UI and on the inbox screen of Android, iOS',
                        },
                    },
                    {
                        label: 'Business Active & Visible',
                        key: 'businessActive',
                        component: checkbox_1["default"].Item,
                        props: {
                            tooltip: 'A User can view and chat with the business',
                        },
                    },
                    {
                        label: 'Show Haptik Branding',
                        key: 'showHaptikBranding',
                        component: checkbox_1["default"].Item,
                        props: function (data) {
                            return {
                                invisible: !data.showHaptikBrandingOption,
                                tooltip: 'Branding of Haptik will be shown above the typing box',
                            };
                        },
                    },
                    {
                        label: 'Enforce GDPR',
                        key: 'gdpr',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Disabled', value: false },
                                { title: 'Enabled Always', value: 'always' },
                                { title: 'Enabled for First 6 Messages', value: true },
                            ],
                        },
                    },
                    {
                        label: 'Enable Per Message User Feedback',
                        key: 'showUserFeedback',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Show Feedback Popover Instantly',
                        key: 'showFeedbackPopoverInstantly',
                        component: radio_1["default"],
                        props: {
                            tooltip: 'Applies only to message-level feedback. The popover will open immediately after feedback is submitted.',
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Positive Question for per message User Feedback',
                        key: 'userFeedbackQuestionPositive',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Positive feedback question asked in detailed feedback',
                            tooltip: 'This text appears when user clicks comment icon after adding a positive feedback.',
                        },
                    },
                    {
                        label: 'Negative Question for per message User Feedback',
                        key: 'userFeedbackQuestionNegative',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Negative feedback question asked in detailed feedback',
                            tooltip: 'This text appears when user clicks comment icon after adding a positive feedback.',
                        },
                    },
                    {
                        label: 'Positive Tags for per message User Feedback',
                        key: 'userFeedbackTagsPositive',
                        component: chips_1["default"],
                    },
                    {
                        label: 'Negative Tags for per message User Feedback',
                        key: 'userFeedbackTagsNegative',
                        component: chips_1["default"],
                    },
                ],
            },
            {
                title: 'JS Configurations',
                inputs: [
                    {
                        label: 'Primary Color',
                        key: 'primaryColor',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Custom Color', value: 'CUSTOM' },
                                { title: 'Blue', value: '#3498db' },
                                { title: 'Indigo', value: '#134696' },
                                { title: 'Green', value: '#2ecc71' },
                            ],
                            tooltip: 'This will define the color of chat button, header and chat bubbles',
                        },
                    },
                    {
                        label: 'Enter Hex Code',
                        key: 'primaryColor2',
                        component: text_1["default"],
                        props: function (form) {
                            return {
                                invisible: form.primaryColor.value !== 'CUSTOM',
                                placeholder: form.primaryColor.value !== 'CUSTOM' ? 'N/A' : 'Hex Code',
                            };
                        },
                    },
                    {
                        label: 'Chat Button Position',
                        key: 'widgetPositioning',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Bottom Left', value: 'bottom-left' },
                                { title: 'Bottom Right', value: 'bottom-right' },
                                { title: 'Center', value: 'center' },
                            ],
                        },
                    },
                    {
                        label: 'Width of Chat UI (Desktop)',
                        key: 'mode',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Thin', value: 'ssm' },
                                { title: 'Wide', value: 'overlay' },
                            ],
                        },
                    },
                    {
                        label: 'User Input Method',
                        key: 'botType',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Text Only', value: 'TEXT' },
                                { title: 'Text + Voice', value: 'VOICE' },
                                { title: 'Voice Only', value: 'VOICE_ONLY' },
                            ],
                        },
                    },
                    {
                        label: 'Initial Input',
                        key: 'voiceBotInitialInput',
                        component: radio_1["default"],
                        props: function (form) { return ({
                            invisible: form.botType.value !== 'VOICE',
                            options: [
                                { title: 'Voice', value: 'VOICE' },
                                { title: 'Keyboard', value: 'KEYBOARD' },
                            ],
                        }); },
                    },
                    {
                        label: 'Disable Features',
                        key: 'disabled',
                        component: dropdown_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Header', value: 'header' },
                                { title: 'Typing Area', value: 'typingArea' },
                                { title: 'Cross Button', value: 'crossButton' },
                                { title: 'Chat Bubble', value: 'chatBubble' },
                            ],
                            searchKeys: ['title'],
                            withSearch: true,
                            withMultiple: true,
                        },
                    },
                    {
                        label: "Override 'Ignore Storage' for Active Chats with Agents (Custom-Signup Bots Only)",
                        key: 'showAgentChatHistory',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                            tooltip: "When this setting is enabled, it overrides the 'Ignore Storage' option for active chats with agents. This means that conversation history will be retained and shown to the user, even if 'Ignore Storage' is turned on, but only while the chat with an agent is active.",
                        },
                    },
                    {
                        label: 'Language Icon',
                        key: 'languageIconConfig',
                        component: SDKChatIcon_1["default"],
                        props: function (form) { return ({
                            optionLabel: false,
                            upload: false,
                            primaryColor: form.primaryColor.value === 'CUSTOM'
                                ? form.primaryColor2
                                : form.primaryColor.value,
                            options: [
                                languageIcon_1["default"].DEFAULT,
                                languageIcon_1["default"].DEVANAGARI,
                            ],
                        }); },
                    },
                    {
                        label: 'Bot Prompt Chat Icon',
                        key: 'chatIconConfig',
                        component: SDKChatIcon_1["default"],
                        props: function (form) { return ({
                            primaryColor: form.primaryColor.value === 'CUSTOM'
                                ? form.primaryColor2
                                : form.primaryColor.value,
                            options: [
                                chatIcon_1["default"].DEFAULT,
                                chatIcon_1["default"].SMILE,
                                chatIcon_1["default"].HELP,
                                chatIcon_1["default"].TEXT,
                                chatIcon_1["default"].IMAGE,
                            ],
                        }); },
                    },
                ],
            },
            {
                title: 'Language Specific SDK Configurations',
                className: 'channels-block-language',
                inputs: [
                    {
                        key: 'select_language',
                        label: 'Select Language',
                        className: 'channels-block-language-dropdown',
                        component: dropdown_1["default"],
                        props: {
                            optionKey: 'name',
                        },
                    },
                    {
                        label: 'Chat Header Text',
                        key: 'headerText',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Header Text',
                            tooltip: 'This text will appear on the header of the chat UI',
                        },
                    },
                    {
                        label: 'Chat Button Text (Desktop)',
                        key: 'buttonTextDesktop',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Button Text (Desktop)',
                        },
                    },
                    {
                        label: 'Chat Button Text (Mobile)',
                        key: 'buttonTextMobile',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Button Text (Mobile)',
                        },
                    },
                    {
                        label: 'Preview Text',
                        key: 'previewText',
                        component: text_1["default"],
                        props: {
                            placeholder: 'Preview text',
                        },
                    },
                    {
                        label: 'Font Family',
                        key: 'fontFamily',
                        component: text_1["default"],
                    },
                    {
                        label: 'Hint Text on Typing Box',
                        key: 'composerPlaceholder',
                        component: text_1["default"],
                        props: {
                            tooltip: 'This text will appear on the footer of the chat UI to guide user to type a mesage',
                        },
                    },
                ],
            },
            {
                inputs: [
                    {
                        label: 'User Signup Required',
                        key: 'customSignup',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Enter Signup Identifier',
                        key: 'customSignupIdentifier',
                        component: text_1["default"],
                        props: function (form) { return ({
                            invisible: !form.customSignup.value,
                            placeholder: !form.customSignup.value
                                ? 'N/A'
                                : 'Custom Signup Identifier',
                        }); },
                    },
                    {
                        label: 'Custom Button',
                        key: 'customButton',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Enter Custom Button Identifier',
                        key: 'customButtonIdentifier',
                        component: text_1["default"],
                        props: function (form) { return ({
                            invisible: !form.customButton.value,
                            placeholder: !form.customButton.value
                                ? 'N/A'
                                : 'DOM Id (#my-button)',
                        }); },
                    },
                    {
                        label: 'Show Typing Suggestions',
                        key: 'showTypingSuggestions',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Always', value: 'always' },
                                { title: 'Only when Menu is shown', value: 'only_menu' },
                                { title: 'Never', value: 'never' },
                            ],
                        },
                    },
                    {
                        label: 'Disable previous buttons as the conversation proceeds',
                        key: 'disablePreviousButtons',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                            tooltip: 'Bot responses can have multiple buttons. As the conversation moves on, the older buttons in the conversation get disabled by default.',
                        },
                    },
                    {
                        label: 'Show timestamp',
                        key: 'showTimestamp',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Display "References" for AISS Answers',
                        key: 'showReferencesSection',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Display Static Guide Message for "References" in AISS Answers',
                        key: 'showReferencesCaptionSection',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Disable Bot Prompt Sound',
                        key: 'disableBotPromptSound',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Bot Prompt Sound',
                        key: 'botPromptSoundUrl',
                        component: notification_1["default"],
                        props: function (form) { return ({
                            invisible: form.disableBotPromptSound.value,
                            options: [notificationTypes_1["default"].DEFAULT, notificationTypes_1["default"].CUSTOM],
                        }); },
                    },
                    {
                        label: 'Bot Response Received Sound',
                        key: 'botMessageSound',
                        component: notification_1["default"],
                        props: function (form) { return ({
                            invisible: false,
                            options: [
                                messageSoundTypes_1["default"].DEFAULT,
                                messageSoundTypes_1["default"].CUSTOM,
                            ],
                        }); },
                    },
                    {
                        label: 'User Sent Message Sound',
                        key: 'userMessageSound',
                        component: notification_1["default"],
                        props: function (form) { return ({
                            invisible: false,
                            options: [
                                messageSoundTypes_1["default"].DEFAULT,
                                messageSoundTypes_1["default"].CUSTOM,
                            ],
                        }); },
                    },
                    {
                        label: 'Give notification sound for every incoming message received once a user moves away',
                        key: 'enableMessageNotificationSound',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                            tooltip: 'Whenever a new message arrives from the Bot/Agent and the end User has either minimized the SDK or has moved over to another tab, a notification sound will be fired',
                        },
                    },
                    {
                        label: 'The notification sound of every incoming message received once a user moves away',
                        key: 'messageNotificationSoundUrl',
                        component: notification_1["default"],
                        props: function (form) { return ({
                            invisible: !form.enableMessageNotificationSound.value,
                            options: [notificationTypes_1["default"].DEFAULT, notificationTypes_1["default"].CUSTOM],
                        }); },
                    },
                    {
                        label: 'Replace the Bot’s Name and Image with the Agent’s Name and Image whenever the Agent enters the conversation',
                        key: 'showAgentData',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Skip automatic scrolling to the bottom of the screen in case of lengthy Bot Responses',
                        key: 'skipAutoScrollToBottom',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Yes', value: true },
                                { title: 'No', value: false },
                            ],
                        },
                    },
                    {
                        label: 'Open Links Using',
                        key: 'openLinksUsing',
                        component: radio_1["default"],
                        props: {
                            optionKey: 'value',
                            options: [
                                { title: 'Default Browser', value: 'default' },
                                { title: 'In-App Webview', value: 'webview' },
                            ],
                            tooltip: 'Choose where links open: in your default browser or inside the app using the in-app webview.',
                        },
                    },
                ],
            },
            {
                inputs: [
                    {
                        key: 'whiteListedDomains',
                        className: 'channels-block-language-dropdown',
                        component: WhiteListDomain_js_1["default"],
                        props: function (form) {
                            return {
                                whiteListedDomains: form.whiteListedDomains,
                            };
                        },
                    },
                ],
            },
            {
                className: 'channels-block-omnichannel',
                inputs: [
                    {
                        label: 'Omnichannel Widget',
                        key: 'omnichannelWidget',
                        component: OmniChannelWidget_1["default"],
                        props: {
                            channels: {
                                whatsapp: {
                                    label: 'WhatsApp',
                                    type: 'whatsapp',
                                    icon: whatsapp_logo_circle_svg_1["default"],
                                    fields: [
                                        {
                                            label: 'WhatsApp Number*',
                                            key: 'whatsapp_number',
                                        },
                                        {
                                            label: 'Pre-filled Message (optional)',
                                            key: 'pre_filled_message',
                                        },
                                    ],
                                },
                                messenger: {
                                    label: 'Facebook',
                                    type: 'messenger',
                                    icon: messenger_logo_circle_svg_1["default"],
                                    fields: [
                                        {
                                            label: 'Page Name*',
                                            key: 'page_name',
                                        },
                                        {
                                            label: 'Reference Parameter (optional)',
                                            key: 'reference_parameter',
                                        },
                                    ],
                                },
                                instagram: {
                                    label: 'Instagram',
                                    type: 'instagram',
                                    icon: instagram_logo_circle_svg_1["default"],
                                    fields: [
                                        {
                                            label: 'Username*',
                                            key: 'username',
                                        },
                                    ],
                                },
                            },
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.FACEBOOK] = {
        id: 1,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Access Token',
                        key: 'access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*App Secret Key',
                        key: 'app_secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Verify Token',
                        key: 'secret_challenge_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: "Requires User's Timezone",
                        key: 'require_users_timezone',
                        component: toggle_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.JIO] = {
        id: 2,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Access Token',
                        key: 'access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.BOT_API] = {
        id: 7,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.WEB_SDK] = {
        id: 9,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.WHATSAPP] = {
        id: 10,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Whatsapp Base URL',
                        key: 'whatsapp_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Whatsapp Username',
                        key: 'whatsapp_username',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Whatsapp Password',
                        key: 'whatsapp_password',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*WABA ID',
                        key: 'waba_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Phone Number (with country code)',
                        key: 'whatsapp_phone_number',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Whatsapp Channel Identifier',
                        key: 'whatsapp_channel_identifier',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Video Enabled',
                        key: 'video_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Whatsapp Pay',
                        key: 'whatsapp_pay_enabled',
                        component: toggle_1["default"],
                        className: 'widthFull',
                        props: function () { return ({ invisible: !store_1["default"].getWhatsappPay() }); },
                    },
                    {
                        label: '*Webhook URL',
                        key: 'whatsapp_pay_url',
                        component: text_1["default"],
                        className: 'widthFull',
                        props: function (deployments, inputValues) {
                            var _a;
                            return ({
                                invisible: ((_a = inputValues.credentials) === null || _a === void 0 ? void 0 : _a.whatsapp_pay_enabled) ? !inputValues.credentials.whatsapp_pay_enabled
                                    : true,
                            });
                        },
                    },
                    {
                        label: '*Enter Payment Configuration ID',
                        key: 'whatsapp_payment_config',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: function (deployments, inputValues) {
                            var _a;
                            return ({
                                invisible: ((_a = inputValues.credentials) === null || _a === void 0 ? void 0 : _a.whatsapp_pay_enabled) ? !inputValues.credentials.whatsapp_pay_enabled
                                    : true,
                            });
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.IOS_SDK] = {
        id: 11,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.ANDROID_SDK] = {
        id: 12,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.JIO_CHAT_CONNECTOR] = {
        id: 13,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Async Webhook URL',
                        key: 'async_webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'User Message Limit',
                        key: 'limit_user_says_value',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Transcript Token',
                        key: 'transcript_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Feedback Links',
                        key: 'feedback_links',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Pre-Checks URL',
                        key: 'pre_checks_url',
                        component: text_1["default"],
                        className: 'widthHalf ',
                    },
                    {
                        label: "*Don't Send Welcome Message to Mogambo",
                        key: 'dont_send_welcome_to_mogambo',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Limit User Message Length?',
                        key: 'limit_user_says',
                        component: toggle_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Perform Pre-Checks Asynchronously',
                        key: 'perform_pre_checks_async',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Perform Welcome With Pre-Checks',
                        key: 'perform_welcome_with_pre_checks',
                        component: toggle_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Valid Keys',
                        key: 'valid_keys',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Welcome Messages',
                        key: 'welcome_messages',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Deep Link Messages',
                        key: 'deep_link_messages',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Pre-Checks Messages',
                        key: 'pre_checks_messages',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Language Fetch Messages',
                        key: 'language_fetch_messages',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Deep Link Messages Responses',
                        key: 'deep_link_messages_responses',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Welcome Message Response',
                        key: 'welcome_message_responses',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'HNI Response',
                        key: 'hni_responses',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Disambiguation Messages',
                        key: 'disambiguation_to_bot_break_messages',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*HNI URL',
                        key: 'hni_url',
                        component: text_1["default"],
                        className: 'widthHalf ',
                    },
                    {
                        label: 'Check HNI',
                        key: 'check_hni',
                        component: toggle_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.GUPSHUP_CHAT_CONNECTOR] = {
        id: 19,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Gupshup Base URL',
                        key: 'gupshup_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Gupshup User ID',
                        key: 'gupshup_userid',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Gupshup Password',
                        key: 'gupshup_password',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: 'Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email IDs',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.NETCORE_CHAT_CONNECTOR] = {
        id: 20,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Netcore Base URL',
                        key: 'netcore_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Netcore Authorization',
                        key: 'netcore_authorization',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Netcore Source',
                        key: 'netcore_source',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.GOOGLE_BUSINESS_MESSAGES] = {
        id: 21,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: 'Brand ID',
                        key: 'brand_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Agent ID',
                        key: 'agent_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Agent Name',
                        key: 'agent_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.SUNSHINE_CHAT_CONNECTOR] = {
        id: 22,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Sunshine Authorization',
                        key: 'app_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: function () { return ({ invisible: true }); },
                    },
                    {
                        label: '*App Id',
                        key: 'app_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Display Name',
                        key: 'display_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Avatar URL',
                        key: 'avatar_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.GIP] = {
        id: 24,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*GIP Bot Name',
                        key: 'gip_bot_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*GIP API Key',
                        key: 'gip_api_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'GIP Break Message',
                        key: 'break_message',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.IVR_AUDIO_CODES] = {
        id: 25,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Initial Expire Time',
                        key: 'initial_expire_time',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Refresh Expire Time',
                        key: 'refresh_expire_time',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Start Message',
                        key: 'start_message',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.TWILIO] = {
        id: 26,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Twilio Password',
                        key: 'twilio_password',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*SMS Destination App',
                        key: 'sms_destination_application_id',
                        component: dropdown_1["default"],
                        props: {
                            optionKey: 'title',
                            placeholder: 'Select SMS Destination App',
                            options: [
                                { title: 'Haptik', value: '1' },
                                { title: 'Interakt', value: '2' },
                            ],
                            searchKeys: ['title'],
                            withSearch: true,
                        },
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Twilio Account',
                        key: 'twilio_account_sid',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Phone Number (with country code)',
                        key: 'twilio_mobile_no',
                        component: text_1["default"],
                        props: {
                            placeholder: '+1**********',
                        },
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Auth Token',
                        key: 'consumer_identifier',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.IVR_APIS] = {
        id: 27,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.INFOBIP_CHAT_CONNECTOR] = {
        id: 30,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Base URL',
                        key: 'infobip_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Scenario Key',
                        key: 'scenario_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '**Authorization Token',
                        key: 'auth_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Language Code',
                        key: 'language_code',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Bot WA Number',
                        key: 'bot_wa_number',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.TELEGRAM] = {
        id: 32,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Telegram Base URL',
                        key: 'telegram_base_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Telegram Access Token',
                        key: 'telegram_access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.SHOPIFY_CONNECTOR] = {
        id: 37,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Domain name',
                        key: 'domain_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*API KEY',
                        key: 'api_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*API TOKEN',
                        key: 'api_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Admin API Enabled',
                        key: 'admin_token_enabled',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Admin API Token',
                        key: 'admin_token',
                        component: text_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Storefront API Enabled',
                        key: 'storefront_token_enabled',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Storefront API Token',
                        key: 'storefront_token',
                        component: text_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Buzzo upload dump url',
                        key: 'upload_product_URL',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Buzzo upload dump secret',
                        key: 'secret',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Buzzo client name',
                        key: 'client_name',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.MICROSOFT_TEAMS] = {
        id: 39,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Microsoft teams client id',
                        key: 'teams_client_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Microsoft teams client secret',
                        key: 'teams_client_secret',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.KMS_INTEGRATION] = {
        id: 40,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*KMS Type',
                        key: 'kms_type',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Bot Name',
                        key: 'bot_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*KMS Settings',
                        key: 'kms_settings',
                        component: text_1["default"],
                        className: 'widthFull',
                        props: {
                            multiline: true,
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.INSTAGRAM] = {
        id: 41,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Instagram Access Token',
                        key: 'access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            multiline: true,
                        },
                    },
                    {
                        label: '*Instagram App Secret Key',
                        key: 'app_secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Haptik Secret Challenge Key',
                        key: 'secret_challenge_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Instagram Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Instagram Page ID',
                        key: 'page_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.LINE] = {
        id: 44,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Line Channel Id',
                        key: 'channel_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Channel access token',
                        key: 'channel_access_token',
                        component: text_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: '*Line Channel Secret',
                        key: 'line_client_secret',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.INSTAGRAM_CLASSIC] = {
        id: 48,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Instagram Classic Access Token',
                        key: 'ic_access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            multiline: true,
                        },
                    },
                    {
                        label: '*Instagram Classic App Secret Key',
                        key: 'ic_app_secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Haptik Secret Challenge Key(Classic)',
                        key: 'ic_secret_challenge_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Instagram Classic Secret Key',
                        key: 'ic_secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Instagram Classic Page ID',
                        key: 'ic_page_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.VIVA_CONNECT] = {
        id: 49,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*User Name',
                        key: 'vc_user_name',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Password',
                        key: 'vc_password',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Api Key',
                        key: 'vc_api_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.GORGIAS_WIDGET] = {
        id: 53,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Gorgias Widget User name',
                        key: 'gorgias_widget_username',
                        component: text_1["default"],
                        className: 'widthHalf ',
                    },
                    {
                        label: '*Gorgias Widget API Base URL',
                        key: 'widget_api_base_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Default Team ID',
                        key: 'gorgias_default_team_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Haptik IVA Gorgias Email',
                        key: 'haptik_iva_gorgias_email',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Haptik IVA Gorgias Id',
                        key: 'haptik_iva_gorgias_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.FYND] = {
        id: 56,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: 'Company ID',
                        key: 'company_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Application ID',
                        key: 'application_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Fynd Base URL',
                        key: 'fynd_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.MAGENTO] = {
        id: 57,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Haptik username',
                        key: 'haptik_username',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Haptik password',
                        key: 'haptik_password',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Magento domain',
                        key: 'magento_domain',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Magento buzzo mapping',
                        key: 'magento_buzzo_mapping',
                        component: text_1["default"],
                        className: 'widthFull',
                        props: {
                            multiline: true,
                        },
                    },
                    {
                        label: '*Magento media url',
                        key: 'magento_media_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Magento store view',
                        key: 'magento_storeview',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Buzzo upload dump url',
                        key: 'upload_product_URL',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Buzzo upload dump secret',
                        key: 'secret',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Buzzo client name',
                        key: 'client_name',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.CLEVERTAP] = {
        id: 58,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Clevertap Webhook URL',
                        key: 'ct_webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf ',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.WOOCOMMERCE] = {
        id: 59,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Domain',
                        key: 'wc_domain',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Username',
                        key: 'wc_username',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Password',
                        key: 'wc_password',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Buzzo upload dump url',
                        key: 'upload_product_URL',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: 'Buzzo upload dump secret',
                        key: 'secret',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Buzzo client name',
                        key: 'client_name',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.RADISYS] = {
        id: 60,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*API Key',
                        key: 'api_key',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Radisys Base URL',
                        key: 'radisys_base_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: 'Radisys Dynamic URL Key',
                        key: 'radisys_dynamic_url_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.MICROSOFT_DYNAMIC_365] = {
        id: 63,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Microsoft Client ID',
                        key: 'microsoft_dynamic_client_id',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Microsoft Client Secret',
                        key: 'microsoft_dynamic_client_secret',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Microsoft Resource URL',
                        key: 'microsoft_dynamic_resource_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Microsoft Service Root URL',
                        key: 'microsoft_dynamic_service_root_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.RCS] = {
        id: 72,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Access Token',
                        key: 'access_token',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Assistant ID',
                        key: 'assistant_id',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                ],
            },
        ],
    },
    _a[tabs_1.DEPLOYMENT_PATHS.VOICE_WEBHOOK] = {
        id: 74,
        blocks: [
            {
                title: '',
                className: 'channels-block-deployments-wrapper',
                inputs: [
                    {
                        label: 'Active',
                        key: 'active',
                        component: toggle_1["default"],
                        className: 'widthFull',
                    },
                    {
                        label: 'Callback URL',
                        key: 'callback_url',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Token',
                        key: 'token',
                        component: text_1["default"],
                        className: 'widthHalf',
                        props: {
                            disabled: true,
                        },
                    },
                    {
                        label: '*Secret Key',
                        key: 'secret_key',
                        component: text_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Webhook URL',
                        key: 'webhook_url',
                        component: text_1["default"],
                        className: 'widthHalf',
                    },
                    {
                        label: '*Webhook Enabled',
                        key: 'webhook_enabled',
                        component: toggle_1["default"],
                        className: 'widthHalf marginRight',
                    },
                    {
                        label: '*Email Ids',
                        key: 'emails',
                        component: chips_1["default"],
                        className: 'widthFull',
                    },
                ],
            },
        ],
    },
    _a);
exports["default"] = INPUTS;
